import {Command} from "../decorators/command.decorator";
import {KnowledgeObject} from "../domain/entities/knowledge-object.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

/**
 * Command to delete a KnowledgeObject entity.
 *
 * Accepts the full entity; the transformer extracts the UID for the backend
 * payload. Carrying the instance (not just the uid) is what lets the handler
 * publish `entity.deleted` with a real `KnowledgeObject`, which the
 * EntityLiveRefreshController matches on via `payload.entity.constructor`.
 */
@Command({type: 'delete', prototype: KnowledgeObject})
export class DeleteKnowledgeObjectCommand extends AbstractCommand<KnowledgeObject> {

    public name: CommandName = CommandName.DELETE_KNOWLEDGE_OBJECT;

    public tags = ['entity', 'delete', 'knowledge-object'];

    constructor(payload: KnowledgeObject) {
        super('knowledgeObject', payload.uid, payload);
    }

}
